export default function AccesDanegate() {
    return (
        <div>
            <h1>AccesDanegate</h1>
        </div>
    )
}
